export default {
  apiKeyPrefix: "Y376891fcBvk.live",
  apiKeySuffix: "lz53ZTZDy60nxL9nXbJDvnYzSN8YYCJN"
};
